import { CanPurchaseDomainErrors } from '../../typing';
import { parseDomain } from '../../utils';
import { dynamicLoadApiQueries } from './dynamicLoadApiQueries';
export const canPurchaseDomain = async _ref => {
  let httpClient = _ref.httpClient,
    domain = _ref.request.domain;
  if (!domain) {
    return {
      canPurchase: false
    };
  }
  const parsedDomain = domain.main ? domain : parseDomain(domain);
  const _await$dynamicLoadApi = await dynamicLoadApiQueries(httpClient),
    domainTlds = _await$dynamicLoadApi.domainTlds;
  const _await$Promise$all = await Promise.all([checkAvailability({
      httpClient,
      request: {
        domain: parsedDomain.asciiDomain
      }
    }), domainTlds({})]),
    availability = _await$Promise$all[0].availability,
    wixSupportedTlds = _await$Promise$all[1].tlds;
  const isAvailable = !!(availability != null && availability.available);
  const isWixSupportedTld = wixSupportedTlds.find(_ref2 => {
    let tld = _ref2.tld;
    return tld === parsedDomain.tld;
  });
  if (!isWixSupportedTld) {
    return {
      error: CanPurchaseDomainErrors.NOT_SUPPORTED_TLD,
      canPurchase: isAvailable,
      premium: availability == null ? void 0 : availability.premium
    };
  }
  if (!isAvailable) {
    return {
      error: CanPurchaseDomainErrors.NOT_AVAILABLE,
      canPurchase: false,
      premium: availability == null ? void 0 : availability.premium
    };
  }
  return {
    canPurchase: true,
    premium: availability == null ? void 0 : availability.premium
  };
};
export const checkAvailability = async _ref3 => {
  let httpClient = _ref3.httpClient,
    domain = _ref3.request.domain;
  const _await$dynamicLoadApi2 = await dynamicLoadApiQueries(httpClient),
    checkDomainAvailability = _await$dynamicLoadApi2.checkDomainAvailability;
  try {
    const _await$checkDomainAva = await checkDomainAvailability({
        domain
      }),
      availability = _await$checkDomainAva.availability;
    return {
      availability
    };
  } catch (e) {
    var _e$response;
    // Don't delete this part
    const statusCode = (e == null || (_e$response = e.response) == null ? void 0 : _e$response.status) ?? (e == null ? void 0 : e.status);
    if (statusCode !== 400) {
      throw e;
    }
    return {
      availability: {
        available: false
      }
    };
  }
};
//# sourceMappingURL=canPurchaseDomain.js.map